import { Link } from 'react-router-dom';
import { api, fmt, type ConversationRow } from '../api';
import { Empty, ErrorNote, Loading, PageHead, StatusChip, useLoad } from '../components/ui';

export default function MyHistory() {
  const { data, error, loading } = useLoad(() => api.get<{ conversations: ConversationRow[] }>('/api/my/conversations'));
  return (
    <>
      <PageHead title="My sessions" sub="Your recent browser conversations and demo calls, with full transcripts." />
      <ErrorNote error={error} />
      {loading && !data ? <Loading /> : !data?.conversations.length ? (
        <Empty>No sessions yet. Start a conversation from “Try the agent”.</Empty>
      ) : (
        <div className="tablewrap">
          <table>
            <thead>
              <tr><th>When</th><th>Agent</th><th>Channel</th><th>Status</th><th className="num">Length</th><th className="num">Turns</th><th /></tr>
            </thead>
            <tbody>
              {data.conversations.map((c) => (
                <tr key={c.id}>
                  <td>{fmt.date(c.started_at)}</td>
                  <td>{c.agent_name}</td>
                  <td>{fmt.channel(c.channel)}{c.phone ? <span className="muted mono"> · {c.phone}</span> : null}</td>
                  <td><StatusChip status={c.status} /></td>
                  <td className="num">{fmt.duration(c.duration_ms)}</td>
                  <td className="num">{c.turns}</td>
                  <td><Link to={`/conversations/${c.id}`}>Transcript</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
